import { createSlice } from '@reduxjs/toolkit'
import { getActiveUsers, getConnectedUsers } from './interactThunks';
import { debouncer } from '../../../../utils/debouncer';
const initialState = {
  userList: [],
  filteredUserList: [],
  roomList: [],
  filteredRoomList: [],
  searchTerm: '',
  filter: 0,
  activeTab: "users", // "users" or "rooms"
  loading: true,
  
}

// Helper function to apply filtering and sorting to users
const getFilteredUserList = (userList, searchTerm, filter) => {
  // First filter by search term (case insensitive on display_name)
  let filtered = userList;
  if (searchTerm)
    filtered = userList.filter(user => 
    user.display_name?.toLowerCase().includes(searchTerm.toLowerCase()) || false
  );
  
  // Then apply sorting based on filter value
  if (filter === 1) {
    // A to Z
    filtered = [...filtered].sort((a, b) => 
      (a.display_name || '').toLowerCase().localeCompare((b.display_name || '').toLowerCase())
    );
  } else if (filter === 2) {
    // Z to A
    filtered = [...filtered].sort((a, b) => 
      (b.display_name || '').toLowerCase().localeCompare((a.display_name || '').toLowerCase())
    );
  }
  // For any other filter value, no sorting is applied
  
  return filtered;
};

// Helper function to apply filtering and sorting to rooms
const getFilteredRoomList = (roomList, searchTerm, filter) => {
  // First filter by search term (case insensitive on label)
  let filtered = roomList;
  if (searchTerm)
    filtered= roomList.filter(room => 
    room.label?.toLowerCase().includes(searchTerm.toLowerCase()) || false
  );
  
  // Then apply sorting based on filter value
  if (filter === 1) {
    // A to Z
    filtered = [...filtered].sort((a, b) => 
      (a.label || '').toLowerCase().localeCompare((b.label || '').toLowerCase())
    );
  } else if (filter === 2) {
    // Z to A
    filtered = [...filtered].sort((a, b) => 
      (b.label || '').toLowerCase().localeCompare((a.label || '').toLowerCase())
    );
  }
  // For any other filter value, no sorting is applied
  
  return filtered;
};

// Helper function to update filtered lists based on current state
const updateFilteredLists = (state) => {
  if (state.activeTab === "users") {
    state.filteredUserList = getFilteredUserList(state.userList, state.searchTerm, state.filter);
  } else if (state.activeTab === "rooms") {
    state.filteredRoomList = getFilteredRoomList(state.roomList, state.searchTerm, state.filter);
  }
};


const interactModalSlice = createSlice({
  name: 'interactModal',
  initialState,
  reducers: {
    setActiveTab : (state, action) => {
      state.loading = true;
      state.filter = 0;
      state.searchTerm = '';
      state.activeTab = action.payload;
      updateFilteredLists(state);

    },
    setRooms:  (state, action) => {
        state.loading = false;
        state.roomList = action.payload;
        updateFilteredLists(state);
    },
    setFilter : (state, action) => {
      state.filter = action.payload;
      updateFilteredLists(state);
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    applySearch: (state, action) => {
      updateFilteredLists(state);
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActiveUsers.fulfilled, (state, action) => {
        state.loading = false;
        // Order by user.socket_id !== null
        state.userList = action.payload
          .filter(user => !user.is_guest)
          .sort((a,b) => (b.online) - (a.online))
        updateFilteredLists(state);
      })
      .addCase(getActiveUsers.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getActiveUsers.rejected, (state, action) => {
        console.error('Failed to fetch active users:', action.error);
      })
      .addCase(getConnectedUsers.fulfilled, (state, action) => {
        state.loading = false;
        // Order by user.socket_id !== null
        state.userList = action.payload
          .filter(user => !user.is_guest)
          .sort((a,b) => (b.online) - (a.online))
        updateFilteredLists(state);
      })
      .addCase(getConnectedUsers.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getConnectedUsers.rejected, (state, action) => {
        console.error('Failed to fetch active users:', action.error);
      })
  }
});

export const {
  setActiveTab,
  setRooms,
  setFilter,
  setSearchTerm,
  applySearch,
} = interactModalSlice.actions;

// Helper function to create debounced search dispatch
export const createDebouncedSearch = (dispatch) => {
  return () => {
    debouncer.debounce('interactModal_search', () => {
      dispatch(applySearch());
    }, 300);
  };
};


export default interactModalSlice.reducer;